import $ from 'jquery'

export default {
    namespaced:true,

    //准备actions--用于响应组件中的actions
    actions: {
      GetQuestionList(context) { // 获取题库所有信息
        $.ajax({
          url: "https://app6132.acapp.acwing.com.cn/api/question/get/",
          type: "post",
          // headers: {
          //   Authorization: "Bearer " + context.rootState.me.token // 这样可以拿到其他模块的数据
          // },
          success(resp) {
            // console.log("成功接收题库 resp == >", resp)
            context.commit("UPDATEQUESTION", resp)
          },
          error(resp) {
            console.log("未成功接收题库， resp == > ", resp)
          }
        })
      },
      SelectQuestionList(context, obj) { // 一个数组 两个字符串
        const new_list = JSON.stringify(obj.list)
        // console.log("option == >", obj.option)
        $.ajax({
          url:"https://app6132.acapp.acwing.com.cn/api/select/question/",
          type: "get",
          data: {
            list: new_list,
            option: obj.option,
            input: obj.input,
            pbfrom: obj.pbfrom,
          },
          success(resp) {
            if (resp.error_message === 'success') {
              // console.log("搜索成功了, resp == >", resp);
              const List = JSON.parse(resp.list);
              // console.log("成功接收题库 List == >", List)
              context.commit("UPDATEQUESTION", List)
            }
            // } else {
            //   console.log("搜索没有完全成功,但是也要更新题库 resp == >", resp.error_message)
            //   const List = JSON.parse(resp.list);
            //   context.commit("UPDATEQUESTION", List)
            // }
          },
          error(resp) {
            console.log("搜索失败了, resp == >", resp)
          }
        })
      },
      SelectExampleList(context, pbid) {
        $.ajax({
          url: "https://app6132.acapp.acwing.com.cn/api/example/select/",
          type: "post",
          data: {
            pbid: pbid,
          },
          headers: {
            Authorization: "Bearer " + context.rootState.me.token // 这样可以拿到其他模块的数据
          },
          success(resp) {
            const List = JSON.parse(resp.List)
            // console.log("成功接收样例 resp == >", List)
            context.commit("UPDATEEXAMPLE", List)
          },
          error(resp) {
            console.log("未成功接收题库， resp == > ", resp)
          }
        })
      },
    },

    //准备mutations--用于操作数据
    mutations: {
      UPDATERECORD(state, data) { /* 提交记录的更新只能是新增 后面可能会考虑用户自己可以删除 */
        state.submitRecord.push(data)
      },
      UPDATEQUESTION(state, data) { /* 更新题库 先无脑前端获取题库 后期再想办法再后端改成只获取 30 / 10 个 */
        state.question = data
        // console.log("更新后的题库: ", state.question)
      },
      UPDATEEXAMPLE(state, data) {
        const list = data;

        state.example = list
        // console.log("更新后的样例：", state.example)
      },
      UPDATENOTES(state, data) {
        state.notes.id = data.id;
        state.notes.pbid = data.pbid
        state.notes.title = data.title
        state.notes.markdown = data.markdown
        state.notes.content = data.content
        state.notes.createtime = data.createtime
        state.notes.userid = data.userid
        state.notes.name = data.name
        state.notes.photo = data.photo
        state.notes.goods = data.goods

        console.log("notes == >", state.notes)
      }
    },

    //创建getters 用于对state的数据进行加工
    getters: {
        
    },

    //准备state--用于存储数据
    state: {
      /* 提交记录 目前是写死的 */
      submitRecord: [{
          submittime: '2016-05-02',
          status: 'Accept',
          lung: 'C++',
          runtime: '114514ms',
          code: "cout << a + b << endl; ",
        }, {
          submittime: '2016-05-02',
          status: 'Accept',
          lung: 'C++',
          runtime: '114514ms',
          code: "cout << a - b << endl; ",
        }, {
          submittime: '2016-05-02',
          status: 'Accept',
          lung: 'C++',
          runtime: '114514ms',
          code: "cout << a * b << endl; ",
        }, {
          submittime: '2016-05-02',
          status: 'Accept',
          lung: 'C++',
          runtime: '114514ms',
          code: "cout << a / b << endl; ",
        }, 
      ],
      
      /* 题库 */
      question:[],

      /* 样例库 */
      example:[],

      /* 题解包含的所有内容 */
      notes: {
        id:'',
        pbid:'',
        title:'',
        markdown:'',
        content:'',
        createtime:'',
        userid:'',
        name:'',
        photo:'',
        goods:'',
      }
    }
}